import React from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';

import Image from 'modules/views/shared/Image';
import { ReactComponent as CloseIcon } from 'assets/icons/ClearWhite.svg';

import { useStyles } from '../styles';

interface IProfileImagePreviewModalProps {
  imageUrl: string | null;
  title?: string;
  onClose: () => void;
}

const ProfileImagePreviewModal: React.FC<IProfileImagePreviewModalProps> = ({ imageUrl, title, onClose }) => {
  const classes = useStyles();

  if (!imageUrl) return null;

  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      className={classes.previewDialog}
      data-testid="profile-image-preview-modal"
    >
      <DialogTitle className={classes.previewDialogTitle} component="div">
        {title}
        <IconButton
          onClick={onClose}
          size="small"
          aria-label="Close preview"
          data-testid="profile-image-preview-close-button"
          className={classes.previewDialogCloseButton}
        >
          <CloseIcon className={classes.galleryDialogCloseIcon} />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.previewContent}>
        <Image
          src={imageUrl}
          alt={title || 'Preview'}
          className={classes.previewImage}
          fallbackClassName={classes.previewImageFallback}
        />
      </DialogContent>
    </Dialog>
  );
};

export default ProfileImagePreviewModal;
